// Firebase Configuration and Initialization
// File: src/firebase.js

import { initializeApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as firebaseSignOut,
  onAuthStateChanged
} from 'firebase/auth'

// TODO: Replace with your Firebase project configuration
// Get this from Firebase Console > Project Settings > Your apps > Web app
const firebaseConfig = {
  apiKey: 'AIzaSyAJBx2VQMn_Nyy7JoKFqB9CTLP_I_hGaLk',
  //  apiKey: 'AIzaSyCTZioXUxUck5vMxMJezv4L9E2p6sP-gp4',
  authDomain: 'organlive-website.firebaseapp.com',
  projectId: 'organlive-website',
  storageBucket: 'organlive-website.firebasestorage.app',
  messagingSenderId: '437836948625',
  appId: '1:437836948625:web:a41b3df6fe18fc983a4b30',
  measurementId: 'G-3ES05SXSTB'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider()

// Optional: Customize Google Sign-In behavior
googleProvider.setCustomParameters({
  prompt: 'select_account' // Always show account picker
})

// Optional: Request additional scopes if needed
// googleProvider.addScope('https://www.googleapis.com/auth/userinfo.profile');

// Export authentication functions for easy import
export { signInWithPopup, firebaseSignOut as signOut, onAuthStateChanged }

export default app
